import { createSlice } from "@reduxjs/toolkit";

const savedToken = localStorage.getItem("token");

const authSlice = createSlice({
  name: "auth",
  initialState: { 
    token: savedToken || null,
    user: null,
    isLoading: false,
    error: null,
    isAuthenticated: !!savedToken,
  },
  reducers: {
    setCredentials: (state, action) => {
      const { accessToken, user } = action.payload;
      state.token = accessToken;
      if (user) {
        state.user = user;
      }
      state.isAuthenticated = true;
      state.error = null;
    },
    logOut: (state) => {
      state.token = null;
      state.user = null;
      state.isAuthenticated = false;
      localStorage.removeItem("token");
      localStorage.removeItem("isAuthenticated");
    },
    loginStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.isLoading = false;
      state.isAuthenticated = true;
      state.error = null;
      if (action.payload) {
        state.user = action.payload;
        if (action.payload.access_token) {
          state.token = action.payload.access_token;
        }
      }
    },
    loginFailure: (state, action) => {
      state.isLoading = false;
      state.isAuthenticated = false;
      state.error = action.payload;
    },
  },
});

export const { setCredentials, logOut, loginStart, loginSuccess, loginFailure } = authSlice.actions;
export default authSlice.reducer;
export const selectCurrentToken = (state) => state.auth.token;
export const selectCurrentUser = (state) => state.auth.user;
